module.exports = __webpack_public_path__ + "img/transmitter.deb219ef.svg";